export default function () {
  return {
    authenticated: false,
    current: {
      active: true,
      alarmEmails: false,
      allOrganizations: false,
      branch: '',
      email: '',
      firstName: '',
      group: '',
      id: '',
      isIntegrator: false,
      lastName: '',
      mobilePhone: '',
      organizations: []
    },
    groupIds: [],
    list: [],
    loggedIn: {
      alarmEmails: false,
      allOrganizations: false,
      branch: '',
      email: '',
      firstName: '',
      id: '',
      isIntegrator: false,
      integrator: '',
      lastName: '',
      mobilePhone: ''
    },
    orgIds: [],
    permissions: {},
    update: {
      active: true,
      alarmEmails: false,
      email: '',
      allOrganizations: false,
      isIntegrator: false,
      firstName: '',
      lastName: '',
      mobilePhone: '',
      branch: '',
      group: ''
    },
    updateLoggedIn: {
      alarmEmails: false,
      email: '',
      firstName: '',
      lastName: '',
      mobilePhone: '',
      password: '',
      allOrganizations: false
    }
  }
}
